import React from 'react';
import Select from 'react-select';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
// import TimePicker from 'react-time-picker';
// import DatePicker from "react-date-picker";
import DatePicker from 'react-datepicker';
import { CustomFields } from '../types/CustomFieldType';
import { getCustomFieldDataSelectLabel, getValueArray } from '../util/FormatUtil';

interface GetFieldProps {
  val;
  selectedItem;
  handleChange;
  fromSamples?;
}
interface GetFieldState {
  selectedItem;
}
export default class GetField extends React.Component<GetFieldProps, GetFieldState> {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: {},
    };
  }

  componentWillReceiveProps(nextProps: Readonly<GetFieldProps>, nextContext: any) {
    if (nextProps.selectedItem) {
      this.setState({ selectedItem: nextProps.selectedItem });
    }
  }

  getCustomFieldData() {
    let data = this.props.selectedItem.CustomFieldData;
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    }
    return data;
  }

  getField(val) {
    let customFieldData = this.getCustomFieldData();
    let customFieldDataCopy = customFieldData ? JSON.parse(JSON.stringify(customFieldData)) : {};
    let fieldTypeID = val.FieldTypeID;

    if (fieldTypeID === CustomFields.TEXT_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-md-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-md-0">
                <input
                  type={'search'}
                  maxLength={val.Options.maxLength}
                  className={'form-control'}
                  value={customFieldData && customFieldData[val.DisplayName] ? customFieldData[val.DisplayName] : ''}
                  autoComplete="off"
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = e.target.value;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.SELECT_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-0">
                <Select
                  isMulti={val.Options.isMulti}
                  isSearchable={true}
                  placeholder={'Please select...'}
                  className={'state_select'}
                  options={val.Options.options}
                  value={customFieldData && customFieldData[val.DisplayName] ? getCustomFieldDataSelectLabel(customFieldData[val.DisplayName], val) : ''}
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = val.Options.isMulti ? getValueArray(e) : e.value;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.DATE_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-0">
                <DatePicker
                  minDate={new Date('01-01-1000')}
                  maxDate={new Date('12-31-9999')}
                  placeholderText="--/--/----"
                  selected={
                    this.props.selectedItem.CustomFieldData && this.props.selectedItem.CustomFieldData[val.DisplayName]
                      ? new Date(this.props.selectedItem.CustomFieldData[val.DisplayName])
                      : ''
                  }
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = e;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
            <div className="row my-2">
              <div className="col-12 text-danger verlag-bold" style={{ fontSize: '1rem' }}>
                *please include '/' when entering date
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.TEXTAREA_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-0">
                <textarea
                  maxLength={val.Options.maxLength}
                  rows={3}
                  className={'form-control'}
                  value={customFieldData && customFieldData[val.DisplayName] ? customFieldData[val.DisplayName] : ''}
                  autoComplete="off"
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = e.target.value;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
            <div className="row pt-1 pr-3 justify-content-end">
              <div className={customFieldData && customFieldData[val.DisplayName] && customFieldData[val.DisplayName].length > 0 ? 'visible' : 'invisible'}>
                <div style={{ fontSize: '0.8em' }}>
                  {customFieldData && customFieldData[val.DisplayName] && customFieldData[val.DisplayName].length}/{val.Options.maxLength}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.NUMBER_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-0">
                <input
                  type={'number'}
                  min={val.Options.min}
                  max={val.Options.max}
                  className={'form-control'}
                  value={customFieldData && customFieldData[val.DisplayName] ? customFieldData[val.DisplayName] : ''}
                  autoComplete="off"
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = e.target.value;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.PHONE_FIELD) {
      return (
        <>
          <div className={'col-12 col-md-4'} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={'col-form-label'} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
            </label>
          </div>
          <div className={this.props.fromSamples ? 'col-12 col-md-8' : 'col-12 col-md-8 pl-md-0 pr-md-1'} id={val.DisplayName}>
            <div className={this.props.fromSamples ? 'row mr-2' : 'row mr-0 ml-0'}>
              <div className="col-12 p-0">
                <PhoneInput
                  placeholder="Enter phone number"
                  defaultCountry="US"
                  value={
                    this.props.selectedItem.CustomFieldData && this.props.selectedItem.CustomFieldData[val.DisplayName]
                      ? this.props.selectedItem.CustomFieldData[val.DisplayName]
                      : ''
                  }
                  onChange={e => {
                    customFieldDataCopy[val.DisplayName] = e;
                    this.setState(
                      prevState => ({
                        selectedItem: {
                          ...prevState.selectedItem,
                          CustomFieldData: customFieldDataCopy,
                        },
                      }),
                      () => this.props.handleChange(this.state.selectedItem)
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  render() {
    return <>{this.getField(this.props.val)}</>;
  }
}
